import userService from "../services/user.service";
import reportService from "../services/report.service";

export const general = {
  namespaced: true,

  state: {
    company: null,
    userId: null,
    companyName: "",
    departmentData: null,
    departments: [],
    employees: [],
    drivers: [],
    statuses: [],
    routeCards: [],
    vehicles: [],
    checkpointNames: [],
    checkpointsOfInsideGates: [],
  },

  actions: {
    async setDepartmentData({ commit }) {
      const response = await userService.getDepartments();

      console.log("getting departments!!");
      console.log(response);
      commit("depsData", response.data);

      // arrange sectors
      let deps = [];
      response.data.forEach((element) => {
        deps.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      commit("deps", deps);

      // arrange employees
      let emps = [];
      response.data.forEach((element) => {
        element.employee.forEach((emp) => {
          // if (emp.value1 == 1) {
          //   console.log(emp);
          // }
          emps.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
        commit("emps", emps);
      });

      // arrange drivers
      let drivers = [];
      response.data.forEach((dep) => {
        if (dep.value1 == 1) {
          // vozaći
          dep.employee.forEach((emp) => {
            if (emp.status) {
              drivers.push({
                name: emp.firstName + " " + emp.lastName,
                id: emp.employeeId,
              });
            }
          });
        }

        // also drivers who's not under 'drivers department'
        dep.employee.forEach((emp) => {
          if (emp.value1 == 1) {
            if (emp.status) {
              drivers.push({
                name: emp.firstName + " " + emp.lastName,
                id: emp.employeeId,
              });
            }
          }
        });

        // also employees explicitelly marked as 'Sandra'
        dep.employee.forEach((emp) => {
          if (emp.string1 === "Sandra") {
            if (emp.status) {
              drivers.push({
                name: emp.firstName + " " + emp.lastName,
                id: emp.employeeId,
              });
            }
          }
        });
        commit("drivers", drivers);
      });
    },

    setStatuses({ commit }) {
      reportService.GetStatuses().then((response) => {
        console.log("getting statuses!!");
        console.log(response.data);
        commit("stats", response.data);
      });

      console.log("getting statuses!");
    },

    setRouteCards({ commit }) {
      userService.getRoutes().then((response) => {
        console.log("getting routes!!");
        console.log(response.data);
        let routeCards = [];

        response.data.forEach((crd) => {
          routeCards.push({
            name: crd.name,
            id: crd.routeId,
          });
        });
        commit("routeCards", routeCards);
      });
    },

    async setCheckpointNames({ commit }) {
      let checkpointNames = await userService.getCheckpointNames();
      console.log("getting checkpoints!!");
      console.log(checkpointNames.data);
      commit("checkpointNames", checkpointNames.data);
    },

    async setCheckpointsOfInsideGates({ commit }) {
      let checkpointsOfInsideGates = await userService.getCheckpointsOfInsideGates();
      console.log("getting checkpoints of inside gates!!");
      console.log(checkpointsOfInsideGates.data);
      commit("checkpointsOfInsideGates", checkpointsOfInsideGates.data);
    },

    async setVehicles({ commit }) {
      let vehicles = await userService.getVehicles();
      console.log("getting vehicles");
      console.log(vehicles.data);
      commit("vehicles", vehicles.data);
    },

    async setCompany({ commit }) {
      let response = await userService.getMyCompany();
      console.log("getting company");
      console.log(response.data);
      commit("company", response.data);
    },

    async setUserId({ commit }) {
      let response = await userService.getMe();
      console.log("getting user id");
      console.log(response.data);
      commit("userid", response.data);
    },
  },

  mutations: {
    emps(state, emps) {
      state.employees = emps;
    },

    drivers(state, drivers) {
      state.drivers = drivers;
    },

    deps(state, deps) {
      state.departments = deps;
    },

    depsData(state, depsData) {
      state.departmentData = depsData;
    },

    stats(state, stats) {
      state.statuses = stats;
    },

    routeCards(state, rts) {
      state.routeCards = rts;
    },

    checkpointNames(state, chkNames) {
      state.checkpointNames = chkNames;
    },

    checkpointsOfInsideGates(state, chkNames) {
      state.checkpointsOfInsideGates = chkNames;
    },

    vehicles(state, vehicles) {
      state.vehicles = vehicles;
    },

    company(state, company) {
      state.company = company;
    },

    userid(state, userId) {
      state.userId = userId;
    },
  },
  // getters: {
  //   employees:
  //     (state) => {
  //       return state.name;
  //     }
  // }
};
